module.exports = __webpack_public_path__ + "static/media/icon-change.aa3b56a3.svg";